import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Box,
  BottomNavigation,
  BottomNavigationAction,
  Button,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Slide,
  Tab,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import { color } from "../../../../StyleData/Config";
import Doc from "./Doc";
import {
  AssignmentInd,
  Clear,
  DisplaySettings,
  Diversity3Outlined,
  Insights,
  MoreHoriz,
  ReceiptLong,
  Speed,
  VerifiedUser,
  VerifiedUserOutlined,
} from "@mui/icons-material";
import ChangeStatus from "./ChangeStatus";
import Meter from "./Meter";
import Transfer from "./Transfer";
import AssignedTo from "./AssignedTo";

import Log from "./Log";
import WarrantyModal from "./WarrantyModal";
import { useDispatch } from "react-redux";

const SlideUpTransition = React.forwardRef(function SlideUpTransition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const tabDetails = {
  "1": { label: "Doc", title: "Documents", icon: <AssignmentInd sx={{ fontSize: color.iconSize }} /> },
  "2": { label: "Change Status", title: "Change Asset Status", icon: <Insights sx={{ fontSize: color.iconSize }} /> },
  "3": { label: "Assigned To", title: "Assigned To", icon: <Diversity3Outlined sx={{ fontSize: color.iconSize }} /> },
  "4": { label: "Meter", title: "Meter", icon: <Speed sx={{ fontSize: color.iconSize }} /> },
  "5": { label: "Warranty", title: "Warranty", icon: <VerifiedUserOutlined sx={{ fontSize: color.iconSize }} /> },
  "6": { label: "Transfer", title: "Transfer", icon: <DisplaySettings sx={{ fontSize: color.iconSize }} /> },
  "7": { label: "Log", title: "Log", icon: <ReceiptLong sx={{ fontSize: color.iconSize }} /> },
};
const allMobileTabs = ["1", "2", "3", "4", "5", "6", "7"];
const primaryMobileTabs = ["1", "2", "3", "4"];
const moreMobileTabs = ["5", "6", "7"];

const ListMenu = ({ contentPosition, data,getData,assetEpl ,enableDisable}) => {
  const dispatch=useDispatch()
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"));
  const [value, setValue] = useState("0");
  const [moreAnchor, setMoreAnchor] = useState(null);
  const handleChange = (event, newValue) => {
    dispatch({type:"drawerOpen",payload:{bol:true,open:false}})
    setValue(newValue);
    contentPosition("column");
  };

  const OnCancel = () => {
    setValue("0");
    contentPosition("row");
    dispatch({type:"drawerOpen",payload:{bol:false,open:false}})
  };

  const handleMobileNavChange = (event, newValue) => {
    if (newValue === "more") {
      return;
    }
    dispatch({ type: "drawerOpen", payload: { bol: true, open: false } });
    setValue(newValue);
  };

  const handleMoreClick = (event) => {
    setMoreAnchor(event.currentTarget);
  };

  const handleMoreSelect = (tabValue) => {
    dispatch({ type: "drawerOpen", payload: { bol: true, open: false } });
    setValue(tabValue);
    setMoreAnchor(null);
  };

  const renderPanelContent = (tabValue) => {
    switch (tabValue) {
      case "1":
        return <Doc data={data.id} enableDisable={enableDisable} />;
      case "2":
        return <ChangeStatus data={data} getData={getData} enableDisable={enableDisable} />;
      case "3":
        return <AssignedTo data={data} refreshData={() => { getData(); }} enableDisable={enableDisable} />;
      case "4":
        return <Meter data={data} enableDisable={enableDisable} />;
      case "5":
        return <WarrantyModal data={data} getData={() => { getData(); }} enableDisable={enableDisable} />;
      case "6":
        return <Transfer data={data} getData={() => { getData(); }} enableDisable={enableDisable} />;
      case "7":
        return <Log data={data.id} />;
      default:
        return null;
    }
  };

  if (isMobile) {
    const tabsToShow = isPhone ? primaryMobileTabs : allMobileTabs;
    const bottomNavValue = tabsToShow.includes(value)
      ? value
      : isPhone && moreMobileTabs.includes(value)
      ? "more"
      : false;
    return (
      <>
        <Paper
          elevation={8}
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: (theme) => theme.zIndex.drawer - 1,
            borderTopLeftRadius: "14px",
            borderTopRightRadius: "14px",
            overflow: "hidden",
            backgroundColor: "#D3E6FC",
          }}
        >
          <BottomNavigation
            showLabels
            value={bottomNavValue}
            onChange={handleMobileNavChange}
            sx={{
              width: "100%",
              justifyContent: "space-evenly",
              backgroundColor: "#D3E6FC",
              "& .Mui-selected": { color: color.TabLabelcolor },
              "& .MuiBottomNavigationAction-label": { fontSize: "0.65rem" },
            }}
          >
            {tabsToShow.map((v) => (
              <BottomNavigationAction
                key={v}
                value={v}
                label={tabDetails[v].label}
                icon={tabDetails[v].icon}
                sx={{ flex: 1, minWidth: 0, maxWidth: "none", color: color.sideTabColor }}
              />
            ))}
            {isPhone && (
              <BottomNavigationAction
                value="more"
                label="More"
                icon={<MoreHoriz sx={{ fontSize: color.iconSize }} />}
                onClick={handleMoreClick}
                sx={{ flex: 1, minWidth: 0, maxWidth: "none", color: color.sideTabColor }}
              />
            )}
          </BottomNavigation>
        </Paper>

        {isPhone && (
          <Menu
            anchorEl={moreAnchor}
            open={Boolean(moreAnchor)}
            onClose={() => setMoreAnchor(null)}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            transformOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            {moreMobileTabs.map((v) => (
              <MenuItem key={v} onClick={() => handleMoreSelect(v)}>
                <Box sx={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
                  {tabDetails[v].icon}
                  {tabDetails[v].label}
                </Box>
              </MenuItem>
            ))}
          </Menu>
        )}

        <Dialog
          open={value !== "0"}
          onClose={OnCancel}
          fullScreen
          TransitionComponent={SlideUpTransition}
          PaperProps={{
            sx: {
              display: "flex",
              flexDirection: "column",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 1.5,
              py: 1,
            }}
          >
            <Box sx={{ width: "2.5rem" }} />
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "1.05rem",
                color: color.sideTitle2Color,
                textAlign: "center",
                flex: 1,
              }}
            >
              {tabDetails[value]?.title}
            </Typography>
            <IconButton onClick={OnCancel}>
              <Clear />
            </IconButton>
          </Box>
          <Divider />
          <Box sx={{ p: 1.5, overflowY: "auto", flex: 1 }}>{renderPanelContent(value)}</Box>
        </Dialog>
      </>
    );
  }

  return (
    <TabContext value={value}>
      {/* <Box sx={{display:"flex",gap:"1rem"}}> */}
      <Grid container spacing={{ xs: "3rem", lg: "2rem" }} sx={{p:0}}>
        <Grid item xs={value !== "0" ? 8 : 0} md={value !== "0" ? 9 : 0} lg={value !== "0" ? 10 : 0}>
          {/* <Box sx={{boxShadow:"-1px 1px 7px 2px rgb(0 0 0 / 32%)",minHeight:"85vh",display:value!=="0"?"block":"none", backgroundColor:"transparent"}}> */}
          <TabPanel value="1" sx={{p:1}}>
            <Doc data={data.id} enableDisable={enableDisable} />
          </TabPanel>
          <TabPanel value="2" sx={{p:1}}>
            <ChangeStatus data={data} getData={getData} enableDisable={enableDisable} />
          </TabPanel>
          <TabPanel value="3"><AssignedTo data={data} refreshData={()=>{getData()}} enableDisable={enableDisable}/></TabPanel>
          <TabPanel value="4" sx={{p:1}}><Meter data={data} enableDisable={enableDisable}/></TabPanel>
          <TabPanel value="5" sx={{p:1}}><WarrantyModal data={data} getData={()=>{getData()}} enableDisable={enableDisable}/></TabPanel>
          <TabPanel value="6" sx={{p:1}}><Transfer data={data} getData={()=>{getData()}} enableDisable={enableDisable}/></TabPanel>
          <TabPanel value="7" sx={{p:1}}><Log data={data.id}/></TabPanel>
          <TabPanel value="0" sx={{ display: "none" }}></TabPanel>
          {/* </Box> */}
        </Grid>
        <Grid
          container
          item
          xs={value !== "0" ? 4 : 12}
          lg={value !== "0" ? 2 : 12}
          md={value !== "0" ? 3 : 12}
          justifyContent={"flex-end"}
        >
          <Box
            sx={{
              ".css-hg18dx-MuiButtonBase-root-MuiTab-root.Mui-selected": {
                color: color.TabLabelcolor,
                // p: 0.5,
              },
              ".css-hg18dx-MuiButtonBase-root-MuiTab-root": {
                alignItems: "flex-start",
              },
              // display: "flex",
              // flexDirection:"column",
              // justifyContent: "flex-end",
              // alignItems: "center",
              // height: value!=="0"?"75.5vh":"100vh",

              gap: "2rem",
              mt: { xs: 0, lg: "1rem" },
            }}
          >
            <Box
              sx={{ display: value !== "0" ? "block" : "none", ml: "1.5rem" }}
            >
              <IconButton sx={{ backgroundColor: "white" }} onClick={OnCancel}>
                <Clear />
              </IconButton>
            </Box>
            <TabList
              orientation="vertical"
              onChange={handleChange}
              aria-label="lab API tabs example"
              TabIndicatorProps={{
                sx: {
                  backgroundColor: color.TabLabelcolor,
                  height: "3px",
                  left: 0,
                },
              }}
              sx={{ backgroundColor: "#D3E6FC", mt: { xs: 0, lg:"1rem"} }}
            >
              <Tab
                icon={
                  <AssignmentInd
                    sx={{ color: color.sideTabColor, fontSize: color.iconSize }}
                  />
                }
                label="Doc"
                value="1"
                sx={{
                  textTransform: "none",
                  color: color.sideTabColor,
                  fontSize: color.label,
                  mb: "0.15rem",
                }}
              />
              <Tab
                icon={
                  <Insights
                    sx={{ color: color.sideTabColor, fontSize: color.iconSize }}
                  />
                }
                label="Change Status"
                value="2"
                sx={{
                  textTransform: "none",
                  color: color.sideTabColor,
                  fontSize: color.label,
                  mb: "0.15rem",
                }}
              />
              <Tab
                icon={
                  <Diversity3Outlined
                    sx={{ color: color.sideTabColor, fontSize: color.iconSize }}
                  />
                }
                label="Assigned To"
                value="3"
                sx={{
                  textTransform: "none",
                  color: color.sideTabColor,
                  fontSize: color.label,
                  mb: "0.15rem",
                }}
              />
              <Tab
                icon={
                  <Speed
                    sx={{ color: color.sideTabColor, fontSize: color.iconSize }}
                  />
                }
                label="Meter"
                value="4"
                sx={{
                  textTransform: "none",
                  color: color.sideTabColor,
                  fontSize: color.label,
                  mb: "0.15rem",
                }}
              />
              <Tab
                icon={
                  <VerifiedUserOutlined
                    sx={{ color: color.sideTabColor, fontSize: color.iconSize }}
                  />
                }
                label="Warranty"
                value="5"
                sx={{
                  textTransform: "none",
                  color: color.sideTabColor,
                  fontSize: color.label,
                  mb: "0.15rem",
                }}
              />
              <Tab
                icon={
                  <DisplaySettings
                    sx={{ color: color.sideTabColor, fontSize: color.iconSize }}
                  />
                }
                label="Transfer"
                value="6"
                sx={{
                  textTransform: "none",
                  color: color.sideTabColor,
                  fontSize: color.label,
                  mb: "0.15rem",
                }}
              />
              <Tab
                icon={
                  <ReceiptLong
                    sx={{ color: color.sideTabColor, fontSize: color.iconSize }}
                  />
                }
                label="Log"
                value="7"
                sx={{
                  textTransform: "none",
                  color: color.sideTabColor,
                  fontSize: color.label,
                  mb: "0.15rem",
                }}
              />
              <Tab
                value="0"
                sx={{
                  display: "none",
                }}
              />
            </TabList>
          </Box>
        </Grid>
      </Grid>
      {/* </Box> */}
    </TabContext>
  );
};

export default ListMenu;
